<!--
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
-->

<div class="samples-container">
  <!-- Overview Section -->
  <div class="samples-overview" *ngIf="!activeDetailPage">
    <p class="intro-text">
      Explore comprehensive authentication and integration samples for the Athena API platform.<br/>
      Each sample demonstrates best practices for securing your application and seamlessly integrating with backend services.
    </p>

    <!-- Sample Categories -->
    <div class="categories-container">
      <div class="sample-category" *ngFor="let category of sampleCategories">
        <div class="category-header">
          <h2>{{ category.name }}</h2>
          <p class="category-description">{{ category.description }}</p>
        </div>

        <!-- Sample Cards Grid -->
        <div class="samples-grid">
          <div class="sample-card" *ngFor="let sample of category.samples">
            <div class="card-header">
              <h3>{{ sample.title }}</h3>
              <h4>{{ sample.subtitle }}</h4>
            </div>
            <div class="card-body">
              <p class="short-description" [innerHTML]="sample.shortDescription"></p>
              <div class="technologies">
                <span class="tech-tag" *ngFor="let tech of sample.technologies">{{ tech }}</span>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn-details" (click)="viewSampleDetails(sample.id)">
                View Details →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Detail Section -->
  <div class="sample-details" *ngIf="activeDetailPage">
    <!-- <button class="btn-back" (click)="closeSampleDetails()">← Back to Samples</button> -->

    <!-- TypeScript Sample -->
    <app-typescript-auth-sample *ngIf="activeDetailPage === 'typescript-auth'"></app-typescript-auth-sample>

    <!-- JavaScript Sample -->
    <app-javascript-auth-sample *ngIf="activeDetailPage === 'javascript-auth'"></app-javascript-auth-sample>

    <!-- Angular Sample -->
    <app-angular-auth-sample *ngIf="activeDetailPage === 'angular-auth'"></app-angular-auth-sample>

    <!-- Backend Node.js Sample -->
    <app-backend-nodejs-sample *ngIf="activeDetailPage === 'backend-nodejs'"></app-backend-nodejs-sample>
  </div>
</div>
